module.exports = __webpack_public_path__ + "img/20bce8e.jpg";